import React from "react";
import { Ptag } from "../fonts";
import {
  ECardDetailWrapper,
  ECardRightSection,
  ECardStrip,
  ECardWrapper,
  InsurerLogoWrapper,
} from "./styles";
import { formatDateReverse } from "../../utils/utils";

const ECard = ({ member, noStrip }) => {
  // formatting relationship
  const formatRelationship = (text) => {
    let title = text;
    switch (text) {
      case "FATHERINLAW":
        title = "Father-in-Law";
        break;
      case "MOTHERINLAW":
        title = "Mother-in-Law";
        break;
    }
    return title.toLowerCase();
  };

  function formatDate(date) {
    let new_date;
    new_date = date.split("-").join("/");
    return new_date;
  }

  return (
    <ECardWrapper>
      {!noStrip && <ECardStrip />}
      <ECardDetailWrapper>
        <div>
          <Ptag fontSize="12px">
            Name
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {member.name}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag
            marginBottom="4px"
            marginTop="4px"
            fontSize="10px"
            fontWeight="400"
          >
            ISSUED BY
          </Ptag>
          <InsurerLogoWrapper>
            <img src={member.insurer} alt="" />
          </InsurerLogoWrapper>
        </ECardRightSection>
        <div>
          <Ptag fontSize="12px">
            Policy Number
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {member.policy_number}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag fontSize="12px">
            Unique Health ID
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {member.client_id || '-'}
          </Ptag>
        </ECardRightSection>
        <div>
          <Ptag fontSize="12px">
            Date of Birth
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {formatDate(member.dob)}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag fontSize="12px">
            Relationship
          </Ptag>
          <Ptag textTransform="capitalize" marginTop="4px" fontSize="16px">
            {formatRelationship(member.relationship)}
          </Ptag>
        </ECardRightSection>
        <div>
          <Ptag fontSize="12px">
            Cover Start Date
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {member.policy_start_date ? formatDateReverse(member.policy_start_date) : "-"}
          </Ptag>
        </div>
        <ECardRightSection>
          <Ptag fontSize="12px">
            Cover End Date
          </Ptag>
          <Ptag marginTop="4px" fontSize="16px">
            {member.policy_end_date ? formatDateReverse(member.policy_end_date) : "-"}
          </Ptag>
        </ECardRightSection>
      </ECardDetailWrapper>
    </ECardWrapper>
  );
};

export default ECard;
